module.exports = __webpack_public_path__ + "img/PGR_A05_back_cross_horizontal_en.2e8e0db2.png";